import BasicField from './basic'

export default class TempoAccountField extends BasicField {
  value() {
    if (typeof this.body === 'object' && this.body) {
      return this.body['id']
    }
  }
}
